import { Selectorispogzpkkfxv as Selector } from './Selector.mjs';
import { default1jaun537xukbl as default_0 } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Defaults.mjs';
import { get_displayNamehv5zo902rjy4 as get_displayName } from './Annotations.mjs';
import { MySealedClassSerializerInterface1lg9fzm3qtbhk as MySealedClassSerializerInterface } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/MySealedClassSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { first58ocm7j58k3q as first } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { get_atTopy2id3zo687kr as get_atTop } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { sizeConstraints19w9rda6g3rqz as sizeConstraints } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import {
  _Constant___init__impl__v45mub2qfk15kh5l39c as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { weight31wqab1913ly4 as weight } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Frame1e7t2kcdb3wu7 as Frame } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Frame.commonHtml.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { RenderContextxikz99gtpuie as RenderContext } from './RenderContext.mjs';
import { reactive2xic0rufq5s8n as reactive } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { text189ciz0cnr32o as text } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl1tl9xt9sj2eem as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfbq6gzmblx5q7v as TextView$_set_content_$ref_pketfb,
} from '../auth/EmailProofComponent.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  cellFormub3o1hqp20e5 as cellForm,
  labeledForm2ame2d0a5lql9 as labeledForm,
  labeledView3rpvir7z2o9ii as labeledView,
  Renderer1fhwti5gmwutm as Renderer,
} from './Renderer.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function registerMySealed(_this__u8e3s4) {
  _this__u8e3s4.register_9awv9l_k$(new (Selector())(), MySealedRenderer_instance);
}
function MySealedRenderer$form$lambda$lambda(it) {
  return default_0(it.serializer_1);
}
function MySealedRenderer$form$lambda$lambda_0(it) {
  return get_displayName(it.serializer_1);
}
function MySealedRenderer$form$lambda$lambda$lambda(it) {
  return it;
}
var MySealedRendererClass;
function MySealedRenderer() {
  if (MySealedRendererClass === VOID) {
    class $ {
      constructor() {
        this.name_1 = 'Options';
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      priority_28tizu_k$(context, module_0) {
        var tmp;
        var tmp_0 = context.serializer_1;
        if (isInterface(tmp_0, MySealedClassSerializerInterface())) {
          tmp = 1.0;
        } else {
          tmp = -1.0;
        }
        return tmp;
      }
      priority_yxj3hb_k$(context, module_0) {
        return this.priority_28tizu_k$(context, module_0);
      }
      columnWidth_g6s04q_k$(context, module_0) {
        return 20.0;
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_g6s04q_k$(context, module_0);
      }
      form_klw3k6_k$(context, value, module_0) {
        println('Sealed used');
        var tmp = context.serializer_1;
        var serializer = isInterface(tmp, MySealedClassSerializerInterface()) ? tmp : THROW_CCE();
        return (_this__u8e3s4) => {
          var tmp = (it) => {
            // Inline function 'kotlin.collections.find' call
            var tmp0 = serializer.get_options_jecmyz_k$();
            var tmp$ret$1;
            $l$block: {
              // Inline function 'kotlin.collections.firstOrNull' call
              var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
              while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
                var element = _iterator__ex2g4s.next_20eer_k$();
                if (element.isInstance_1(it)) {
                  tmp$ret$1 = element;
                  break $l$block;
                }
              }
              tmp$ret$1 = null;
            }
            var tmp0_elvis_lhs = tmp$ret$1;
            return tmp0_elvis_lhs == null ? first(serializer.get_options_jecmyz_k$()) : tmp0_elvis_lhs;
          };
          var type = value.lens_drj4fu_k$(tmp, MySealedRenderer$form$lambda$lambda);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(false);
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          var this_0 = sizeConstraints(get_atTop(element), VOID, VOID, VOID, VOID, VOID, get_rem(10));
          // Inline function 'com.lightningkite.kiteui.views.direct.select' call
          var this_1 = themed(this_0, FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (Select())(this_1.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          this_1.willAddChild_hz2iwc_k$(element_0);
          var tmp_0 = _Constant___init__impl__v45mub(serializer.get_options_jecmyz_k$());
          element_0.bind_64a41i_k$(type, new (Constant())(tmp_0), MySealedRenderer$form$lambda$lambda_0);
          element_0.onStartup_vrxh3i_k$();
          this_1.addChild_2qpft2_k$(element_0);
          // Inline function 'com.lightningkite.kiteui.views.expanding' call
          // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
          var this_2 = weight(element, 1.0);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = new (Frame())(this_2.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          this_2.willAddChild_hz2iwc_k$(element_1);
          var $this$frame = element_1;
          reactive($this$frame, VOID, ($this$reactive) => {
            var selectedType = $this$reactive.invoke_r7m7el_k$(type);
            $this$frame.clearChildren_eufjq4_k$();
            var tmp = selectedType.serializer_1;
            var subSerializer = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
            var subContext = new (RenderContext())(subSerializer, context.fieldAnnotations_1);
            var tmp_0 = (it) => selectedType.isInstance_1(it) ? it : default_0(subSerializer);
            var subValue = value.lens_drj4fu_k$(tmp_0, MySealedRenderer$form$lambda$lambda$lambda);
            module_0.form_gqhwsi_k$(subContext, subValue)($this$frame);
            return Unit_instance;
          });
          element_1.onStartup_vrxh3i_k$();
          this_2.addChild_2qpft2_k$(element_1);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_klw3k6_k$(context, value, module_0);
      }
      view_3m91zp_k$(context, value, module_0) {
        var tmp = context.serializer_1;
        var serializer = isInterface(tmp, MySealedClassSerializerInterface()) ? tmp : THROW_CCE();
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(false);
          var $this$row = element;
          reactive($this$row, VOID, ($this$reactive) => {
            $this$row.clearChildren_eufjq4_k$();
            var currentValue = $this$reactive.invoke_r7m7el_k$(value);
            // Inline function 'kotlin.collections.find' call
            var tmp0 = serializer.get_options_jecmyz_k$();
            var tmp$ret$5;
            $l$block: {
              // Inline function 'kotlin.collections.firstOrNull' call
              var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
              while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
                var element = _iterator__ex2g4s.next_20eer_k$();
                if (element.isInstance_1(currentValue)) {
                  tmp$ret$5 = element;
                  break $l$block;
                }
              }
              tmp$ret$5 = null;
            }
            var tmp0_elvis_lhs = tmp$ret$5;
            var selectedType = tmp0_elvis_lhs == null ? first(serializer.get_options_jecmyz_k$()) : tmp0_elvis_lhs;
            text($this$row, get_displayName(selectedType.serializer_1));
            // Inline function 'com.lightningkite.kiteui.views.direct.space' call
            var this_0 = $this$row;
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_0 = new (Space())(this_0.get_context_h02k06_k$());
            ensureOutermostElement(element_0);
            this_0.willAddChild_hz2iwc_k$(element_0);
            element_0.onStartup_vrxh3i_k$();
            this_0.addChild_2qpft2_k$(element_0);
            var tmp = selectedType.serializer_1;
            var subSerializer = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
            var subContext = new (RenderContext())(subSerializer, context.fieldAnnotations_1);
            var subValue = lens(value, (it) => selectedType.isInstance_1(it) ? it : default_0(subSerializer));
            module_0.view_ntgxjz_k$(subContext, subValue)($this$row);
            return Unit_instance;
          });
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_3m91zp_k$(context, value, module_0);
      }
      cellView_hcodjr_k$(context, value, module_0) {
        var tmp = context.serializer_1;
        var serializer = isInterface(tmp, MySealedClassSerializerInterface()) ? tmp : THROW_CCE();
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
            var currentValue = $this$invoke.invoke_r7m7el_k$(value);
            // Inline function 'kotlin.collections.find' call
            var tmp0 = serializer.get_options_jecmyz_k$();
            var tmp$ret$4;
            $l$block: {
              // Inline function 'kotlin.collections.firstOrNull' call
              var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
              while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
                var element = _iterator__ex2g4s.next_20eer_k$();
                if (element.isInstance_1(currentValue)) {
                  tmp$ret$4 = element;
                  break $l$block;
                }
              }
              tmp$ret$4 = null;
            }
            var tmp0_elvis_lhs = tmp$ret$4;
            var selectedType = tmp0_elvis_lhs == null ? first(serializer.get_options_jecmyz_k$()) : tmp0_elvis_lhs;
            return get_displayName(selectedType.serializer_1);
          });
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      cellView_2dvin1_k$(context, value, module_0) {
        return this.cellView_hcodjr_k$(context, value, module_0);
      }
    }
    protoOf($).cellForm_4mayde_k$ = cellForm;
    protoOf($).labeledForm_ughtr2_k$ = labeledForm;
    protoOf($).labeledView_aldyvt_k$ = labeledView;
    initMetadataForObject($, 'MySealedRenderer', VOID, VOID, [Renderer()]);
    MySealedRendererClass = $;
  }
  return MySealedRendererClass;
}
var MySealedRenderer_instance;
function MySealedRenderer_getInstance() {
  return MySealedRenderer_instance;
}
//region block: init
MySealedRenderer_instance = new (MySealedRenderer())();
//endregion
//region block: exports
export {
  registerMySealed as registerMySealed3nr0obmvs3xjq,
};
//endregion

//# sourceMappingURL=MySealedRenderer.mjs.map
